<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import Modal from "@shared/svelte/Components/Modal.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import FizzStyles from "@shared/svelte/Components/FizzStyles.svelte";
  import ChatWithSupportLink from "./ChatWithSupportLink.svelte";

  export let showModal: boolean;

  const dispatch = createEventDispatcher();

  const close = () => {
    showModal = false;
    dispatch("close");
  };

</script>

<FizzStyles>
  <Modal bind:show={showModal} fizzModal={true} size="small" closeOnBackgroundClick={true}>
    <header class="fizz-modal-header" data-testid="adding-account-number-help-modal">
      <h4 class="fizz-heading-4">Distributor account number</h4>
      <button class="fizz-icon-button-small fizz-modal-toggle fizz-modal-close" on:click={close}>
        <Icon type="X" extraClassNames="fizz-text-brand" height="16" width="16" />
      </button>
    </header>

    <section class="fizz-modal-main fizz-text-medium">
      <p>
        Provi partners with some distributors in your area to send orders directly to their system
        to be processed. In order to successfully send orders to this distributor, we need to know
        your account number.
      </p>
    </section>
    <section class="fizz-modal-main fizz-text-medium">
      <p>
        If you don’t know your account number, reach out to your distributor or
        <ChatWithSupportLink message="contact us." bold={false} onClick={close} />
      </p>
    </section>
  </Modal>
</FizzStyles>
